/**
 * Ruído conhecido em error tracking — não indica bug da aplicação.
 * Mantém PostHog focado em falhas acionáveis do produto.
 */
export function shouldDropPostHogExceptionEvent(properties: Record<string, unknown>): boolean {
  const types = properties.$exception_types
  const values = properties.$exception_values
  const messages = [
    ...(Array.isArray(types) ? types.map(String) : []),
    ...(Array.isArray(values) ? values.map(String) : []),
  ]
    .join(" ")
    .toLowerCase()

  if (!messages.trim()) return false

  if (messages.includes("script error")) return true
  if (messages.includes("java object is gone")) return true
  if (messages.includes("enableDidUserTypeOnKeyboardLogging".toLowerCase())) return true
  if (messages.includes("aborterror") && messages.includes("aborted")) return true
  if (messages.includes("addlistener") && messages.includes("cannot read properties of undefined")) {
    return true
  }

  return false
}
